import { ValidationError } from "@utils/form"
import * as yup from "yup"

export const getFormSchema = () => {
  return yup.object({
    rows: yup
      .array()
      .required()
      .of(
        yup.object({
          type: yup.string().oneOf(["text", "dropdown"]).required(ValidationError.REQUIRED),
          name: yup.string().required(ValidationError.REQUIRED),

          // value is required for dropdown type, otherwise it has to stay empty
          value: yup.string().when("type", ([type], schema) => {
            if (type === "text") return schema.test("empty-for-text", (value) => value === "")

            return schema.required(ValidationError.REQUIRED)
          }),

          // description is optional, for text type it has to stay empty
          description: yup.string().when("type", ([type], schema) => {
            if (type === "text") return schema.test("empty-for-text", (value) => value === "")

            return schema
          }),
        }),
      )
      .test("unique-text-tags-names", "", function (rows, ctx) {
        const textTagsNames = rows.filter((row) => row.type === "text").map((row) => row.name)
        const nonUniqueTextTagsNames = textTagsNames.filter(
          (name, index) => textTagsNames.indexOf(name) !== index,
        )

        if (nonUniqueTextTagsNames.length > 0) {
          return ctx.createError({
            message: `Duplicate text tag names: ${nonUniqueTextTagsNames.join(", ")}`,
          })
        }

        return true
      })
      .test("unique-tag-name-and-type", "", function (rows, ctx) {
        const textTagNames = rows.filter((row) => row.type === "text").map((row) => row.name)
        const uniqueTextTagNames = new Set(textTagNames)

        const dropdownTagNames = rows
          .filter((row) => row.type === "dropdown")
          .map((row) => row.name)
        const uniqueDropdownTagNames = new Set(dropdownTagNames)

        const sharedTagNames = uniqueTextTagNames.intersection(uniqueDropdownTagNames)

        if (sharedTagNames.size > 0) {
          return ctx.createError({
            message: `The same tag names are used with different types: ${Array.from(
              sharedTagNames,
            ).join(", ")}`,
          })
        }

        return true
      })
      .test("unique-tag-options", "", function (rows, ctx) {
        const dropdownRows = rows.filter((row) => row.type === "dropdown")

        const duplicates: string[] = []
        const seenValuesByName = new Map<string, Set<string>>()

        for (const row of dropdownRows) {
          const value = row.value ?? ""
          const seenValues = seenValuesByName.get(row.name) ?? new Set<string>()

          if (seenValues.has(value)) {
            duplicates.push(`"${row.name}" -> "${value}"`)
          }

          seenValues.add(value)
          seenValuesByName.set(row.name, seenValues)
        }

        if (duplicates.length > 0) {
          return ctx.createError({
            message: `Duplicated tag options values: ${duplicates.join(", ")}`,
          })
        }

        return true
      }),
  })
}
